import { render, staticRenderFns } from "./client-info.vue?vue&type=template&id=05dfc8c5&scoped=true&"
import script from "./client-info.vue?vue&type=script&lang=js&"
export * from "./client-info.vue?vue&type=script&lang=js&"
import style0 from "./client-info.vue?vue&type=style&index=0&id=05dfc8c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dfc8c5",
  null
  
)

export default component.exports